import { Box } from "@primer/react";
import ThongKePage from "../thong-ke";
const HomePage = () => {

  return (
    <Box>
      <ThongKePage />
    </Box>

  );
}
export default HomePage
